import { colorSet } from '@components/Provider';
import { makeStyles } from '@material-ui/core';

export const usePartnerEvalutateStyles = makeStyles((theme) => {
  return {
    dialogWrapper: {
      boxShadow:
        '0px 6px 6px -3px rgba(0, 0, 0, 0.2), 0px 10px 14px 1px rgba(0, 0, 0, 0.14), 0px 4px 18px 3px rgba(0, 0, 0, 0.12)',
      '& .MuiDialog-container': {
        '& .MuiDialog-paperWidthSm': {
          maxWidth: 486,
          [theme.breakpoints.down('xs')]: {
            width: '100%',
            margin: 16
          }
        }
      }
    },

    dialogTitle: {
      padding: '24px 24px 12px 24px'
    },
    dialogContent: {
      padding: '0px 8px 24px 8px',
      '& span': {
        fontSize: 14,
        fontWeight: 400
      }
    },
    title: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      fontSize: 16,
      fontWeight: 700,
      lineHeight: '24px',
      letterSpacing: '-0.1px'
    },
    subtitle: {
      fontWeight: 500,
      fontSize: 14,
      lineHeight: '20px',
      letterSpacing: '-0.1px'
    },
    action: {
      justifyContent: 'center',
      padding: '16px 24px 24px 24px'
    },
    textfield: {
      '& ::placeholder': {
        fontSize: 14,
        fontWeight: 400,
        whiteSpace: 'pre-line'
      },
      '& .MuiFormHelperText-contained': {
        color: colorSet.errorMain
      }
    },
    opnion: {
      fontSize: 14,
      fontWeight: 500,
      marginBottom: 20
    }
  };
});

export const useCapaEvalutateStyles = makeStyles((theme) => {
  return {
    dialogWrapper: {
      boxShadow:
        '0px 6px 6px -3px rgba(0, 0, 0, 0.2), 0px 10px 14px 1px rgba(0, 0, 0, 0.14), 0px 4px 18px 3px rgba(0, 0, 0, 0.12)',
      '& .MuiDialog-container': {
        '& .MuiDialog-paperWidthSm': {
          maxWidth: 486,
          [theme.breakpoints.down('xs')]: {
            width: '100%',
            margin: 16
          }
        }
      }
    },

    dialogTitle: {
      padding: '24px 24px 12px 24px'
    },
    dialogContent: {
      padding: '0px 8px 24px 8px',
      '& span': {
        fontSize: 14,
        fontWeight: 400
      }
    },
    title: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      fontSize: 16,
      fontWeight: 700,
      lineHeight: '24px',
      letterSpacing: '-0.1px'
    },
    action: {
      justifyContent: 'center',
      padding: '16px 24px 24px 24px'
    },
    textfield: {
      '& ::placeholder': {
        fontSize: 14,
        fontWeight: 400,
        whiteSpace: 'pre-line'
      }
    },
    opnion: {
      fontSize: 14,
      fontWeight: 500,
      marginBottom: 20
    },
    svg: {
      marginTop: 12,
      marginBottom: 32,
      '& .MuiRating-icon': {
        marginRight: 5,
        '& > svg': {
          stroke: {
            fill: '#939FA5'
          }
        }
      },
      '& .MuiRating-iconFilled': {
        '& > svg': {
          '& .MuiRating-label': {
            marginRight: 5
          },
          stroke: colorSet.gray000,
          '& > circle': {
            fill: colorSet.warningDark,
            stroke: colorSet.warningDark
          },
          '& > path': {
            fill: colorSet.gray000
          }
        }
      }
    },
    recommendText: {
      fontSize: 14,
      fontWeight: 500,
      lineHeight: '20.02px',
      letterSpacing: '-0.1px'
    }
  };
});
